require('./bootstrap');
require('./config');

import Vue from "vue";
import Vuex from "vuex";
import VueI18n from 'vue-i18n';
import VueRouter from "vue-router";
import VeeValidate from 'vee-validate';
import VueSweetalert2 from "vue-sweetalert2";
import VueCurrencyInput from 'vue-currency-input';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import validationMessages from 'vee-validate/dist/locale/es';
import VueMobileDetection from "vue-mobile-detection";
import VueChatScroll from 'vue-chat-scroll';
import VueClipboard from 'vue-clipboard2';
import VueQrcodeReader from "vue-qrcode-reader";
import VueTelInput from 'vue-tel-input';
import VueMask from 'v-mask';
import VueMoment from 'vue-moment';
import CKEditor from 'ckeditor4-vue';
import JsonViewer from 'vue-json-viewer';
import routes from "./routes";
import store from "./store";
import App from "./components/AppComponent";

window.Vue = require("vue");
const i18n = new VueI18n({
    locale: 'es'
});
const moment = require('moment');
require('moment/locale/es');

const currencyOptions = {
    globalOptions: {
        locale: 'en-US',
        currency: null,
        valueAsInteger: false,
        distractionFree: true,
        precision: 2,
        autoDecimalMode: true,
        valueRange: { min: 0 },
        allowNegative: false
    }
}
const validateOptions = {
    inject: true,
    fieldsBagName: "veeFields",
    errorBagName: "veeErrors",
    i18nRootKey: 'validations',
    i18n,
    dictionary: {
        es: validationMessages
    }
}
VueClipboard.config.autoSetContainer = true;

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(VueAwesomeSwiper);
Vue.use(VeeValidate, validateOptions);
Vue.use(VueCurrencyInput, currencyOptions);
Vue.use(VueMobileDetection);
Vue.use(VueChatScroll);
Vue.use(VueClipboard);
Vue.use(VueQrcodeReader);
Vue.use(VueTelInput);
Vue.use(CKEditor);
Vue.use(VueMask);
Vue.use(VueMoment, { moment });
Vue.use(JsonViewer);

const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title + ' | MoreGiros';

    if (store.getters['token'] && !store.getters['check']) {
        try {
            await store.dispatch('fetchUser');
        } catch (e) {}
    }

    let route = reroute(to);
    if (route) {
        next(route);
    } else {
        next();
    }
});

const rules = {
    guest: { fail: 'Home', check: () => (!store.getters['check']) },
    auth: { fail: 'Login', check: () => (store.getters['check']) }
};

function reroute(to) {
    let failRoute = false,
        checkResult = false;

    to.meta.rules && to.meta.rules.forEach(rule => {
        let check = false;
        if (Array.isArray(rule)) {
            let checks = [];
            for (let i in rule) {
                checks[i] = rules[rule[i]].check();
                check = check || checks[i];
            }
            if (!check && !failRoute) {
                failRoute = rules[rule[checks.indexOf(false)]].fail;
            }
        } else {
            check = rules[rule].check();
            if (!check && !failRoute) {
                failRoute = rules[rule].fail;
            }
        }

        checkResult = checkResult && check;
    });

    const lp = window.location.pathname;
    const lq = window.location.search;

    if (!checkResult && failRoute) {
        if (failRoute === 'Login') {
            return {name: failRoute, query: {to: lp + lq}};
        } else {
            return {name: failRoute};
        }
    }

    return false;
}

export default router;

export const app = new Vue({
    el: '#app',
    icons: {
        iconfont: [
            'mdi',
            'fa'
        ]
    },
    router,
    store,
    components: { App }
});
